import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private subjects: Map<string, BehaviorSubject<any>> = new Map();

  constructor() {
    window.addEventListener('storage', (event) => {
      if (event.key) {
        this.updateSubject(event.key, event.newValue ? JSON.parse(event.newValue) : null);
      }
    });
  }

  /** Set item in localStorage and notify subscribers */
  setItem<T>(key: string, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
    this.updateSubject(key, value);
  }

  /** Get item from localStorage */
  getItem<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  /** Observe changes for a specific key */
  observeItem<T>(key: string): Observable<T | null> {
    if (!this.subjects.has(key)) {
      this.subjects.set(key, new BehaviorSubject<T | null>(this.getItem<T>(key)));
    }
    return this.subjects.get(key)!.asObservable();
  }

  /** Remove item from localStorage */
  removeItem(key: string): void {
    localStorage.removeItem(key);
    this.updateSubject(key, null);
  }

  /** Update the BehaviorSubject when localStorage changes */
  private updateSubject<T>(key: string, value: T | null): void {
    if (!this.subjects.has(key)) {
      this.subjects.set(key, new BehaviorSubject<T | null>(value));
    } else {
      this.subjects.get(key)!.next(value);
    }
  }
}
